import IVenue from "../interfaces/IVenue";
import { HTTPMethods } from "../yoello-lib/modules/API/API";
import APIExtensions from "../yoello-lib/modules/API2/APIDefs";
import { useAPIV2 } from "../yoello-lib/modules/API2/useAPIv2";
import { useIsSuperuser } from "./useIsSuperuser";


/**Gets all users venues
 * WILL NOT WORK FOR SUPER USERS
 */
export function useGetAllVenues() {
    const { isSuperuser } = useIsSuperuser();
    const { callAPI , isLoading } = useAPIV2<IVenue[]>(APIExtensions.venues, { params: { include_disabled: true, size: 30 }, isPaginated: true, onMountDisabled: true, canAPIGetCacheValue: false });

    const getAllVenues = () => {
        if (isSuperuser) return;
        callAPI(HTTPMethods.GET, { canAPIGetCacheValue: false });
    }

    return {
        getAllVenues,
        isLoading
    }
}